import { RoundedBox } from '@react-three/drei'
import { Shape } from 'three'
import { useVerandaSelector } from '../../../..'
import { Helper } from '../../../../classes/helper'
import { useMarquee } from '../../../../hooks/state/useMarquee'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../material/cachedMeshPhysicalMaterial'

interface Props {
  positionX: any
}

export const Farbric = ({ positionX }: Props): JSX.Element => {
  const { polesTopNumber, userWidth, verandaTyp, depth, attachedSize } =
    useMeasures()
  const { marqueeFabricColor } = useMarquee()
  const { roofGlassDepth } = useRoof()
  const shadingMode = useVerandaSelector((state) => state.scene.shadingMode)

  const roofWidth = userWidth / (polesTopNumber - 1)
  const position =
    positionX! === 0
      ? roofWidth! * positionX - 0.015
      : roofWidth! * positionX - verandaTyp.roofBar.depth / 2

  const fabricWidth = roofGlassDepth
    ? roofWidth -
      verandaTyp.roofBar.depth -
      (positionX ? 0 : verandaTyp.roofBar.depth)
    : roofWidth - verandaTyp.log.width / 2

  const fabricLength = 0.1
  const fabricHeight = shadingMode ? 0.0008 : 0.007

  const maxSingleFabricWidth = Math.ceil(depth / fabricLength)
  const inAndOut = !shadingMode
    ? -0.03 * maxSingleFabricWidth
    : -depth + verandaTyp.bar.depth / 2 + attachedSize.y / 2
  const sinlgeFabricWidth = inAndOut / maxSingleFabricWidth

  const shape = new Shape()

  shape
    .moveTo(0, 0)
    .quadraticCurveTo(
      0,
      -fabricHeight * maxSingleFabricWidth,
      -sinlgeFabricWidth,
      0
    )
    .quadraticCurveTo(0, -fabricHeight - 0.001, 0, 0)

  const extrudeSettings = {
    steps: 1,
    depth: fabricWidth,
    bevelEnabled: false,
  }

  return (
    <group
      position={[
        userWidth! / 2 - fabricWidth / 2 - roofWidth! / 2 - position - 0.025,
        roofGlassDepth ? verandaTyp.roofBar.width / 2 : 0,
        -attachedSize.y / 2,
      ]}
      rotation={[0, Helper.convertAngleToRadiant(90), 0]}
    >
      {[...Array(maxSingleFabricWidth - 1)].map((_, index) => {
        return (
          <>
            <mesh
              key={`maxSingleFabricWidth${index}`}
              position={[
                sinlgeFabricWidth +
                  sinlgeFabricWidth / 2 +
                  sinlgeFabricWidth * index,
                0,
                0,
              ]}
              castShadow
            >
              <extrudeGeometry
                attach="geometry"
                args={[shape, extrudeSettings]}
              />

              <CachedMeshPhysicalMaterial
                color={marqueeFabricColor}
                opacity={0.99}
                roughness={1}
                metalness={0}
                envMapIntensity={0.2}
              />
            </mesh>

            {!index && (
              <mesh
                position={[
                  inAndOut - sinlgeFabricWidth / 2 - 0.005,
                  0,
                  fabricWidth / 2,
                ]}
                rotation={[
                  Helper.convertAngleToRadiant(0),
                  Helper.convertAngleToRadiant(90),
                  Helper.convertAngleToRadiant(0),
                ]}
                castShadow
              >
                <RoundedBox
                  args={[fabricWidth, 0.02, 0.01]}
                  radius={0.001}
                  matrixWorldAutoUpdate={undefined}
                  getObjectsByProperty={undefined}
                  getVertexPosition={undefined}
                >
                  <CachedMeshPhysicalMaterial
                    color={'grey'}
                    opacity={1}
                    roughness={0}
                    metalness={1}
                    envMapIntensity={0}
                  />
                </RoundedBox>
              </mesh>
            )}
          </>
        )
      })}

      {[...Array(2)].map((_, index) => {
        return (
          <mesh
            position={[-depth / 2, 0, fabricWidth * index]}
            rotation={[
              Helper.convertAngleToRadiant(0),
              Helper.convertAngleToRadiant(0),
              Helper.convertAngleToRadiant(0),
            ]}
            castShadow
            key={`Fabric${index}`}
          >
            <RoundedBox
              args={[
                depth - verandaTyp.bar.depth - attachedSize.y,
                0.02,
                0.025,
              ]}
              radius={0.01}
              matrixWorldAutoUpdate={undefined}
              getObjectsByProperty={undefined}
              getVertexPosition={undefined}
            >
              <CachedMeshPhysicalMaterial
                color={'grey'}
                opacity={1}
                roughness={0}
                metalness={1}
                envMapIntensity={0}
              />
            </RoundedBox>
          </mesh>
        )
      })}
    </group>
  )
}
